module.exports = __webpack_public_path__ + "img/lois.26b4e77c.jpg";